// extracted by mini-css-extract-plugin
export var active = "_9p-a";
export var activeIndicator = "_9p-8";
export var animate = "_9p-9";
export var disabled = "_9p-b";
export var fullWidth = "_9p-2";
export var lg = "_9p-7";
export var md = "_9p-6";
export var redoButtonTabGroup = "_9p-0";
export var sm = "_9p-5";
export var tabButton = "_9p-3";
export var tabButtonsContainer = "_9p-1";
export var xs = "_9p-4";